<template>
<div class="dash_board_chart"></div>
</template>

<script>
//仪表盘不是常用图表，需要单独引入
import Highcharts from "highcharts/highstock";
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge.js'
HighchartsMore(Highcharts)
SolidGauge(Highcharts);
export default {
  name: "DashBoard",
  props: {
    titleText: {
      type: String,
      required: true,
    },
    seriesData: {
      type: Number,
      default: 0,
      required: true,
    }
  },
  data(){
    return{
      chart: null,
    }
  },
  mounted() {
    this.initChart();
    this.chart.showLoading();
  },
  watch: {
    seriesData: {
      handler(newValue) {
        if (this.chart) {
          let point = this.chart.series[0].points[0];
          point.update(newValue);
        }
        this.chart.hideLoading();
      },
    },
  },
  methods: {
    initChart(){
      this.chart = new Highcharts.Chart(this.$el, {
        credits: {
          enabled: false
        },
        chart: {
          type: 'solidgauge',
          spacingBottom: 0,
          spacingTop: 0,
        },
        title: null,
        pane: {
          center: ['50%', '75%'],
          size: '100%',
          startAngle: -90,
          endAngle: 90,
          background: {
            backgroundColor: '#EEE',
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          stops: [
              [0.1, '#F56C6C'],
              [0.5, '#409EFF'],
              [1, '#67C23A']
          ],
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          tickWidth: 0,
          labels: {
            y: 16
          },
          min: 0,
          max: 100,
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [this.seriesData],
          type: 'solidgauge',
          dataLabels: {
            format: '<div style="text-align:center"><span style="font-size:25px;color:' +
                ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y}%</span><br/>' +
                '<span style="font-size:12px;color:silver">'+ this.titleText +'</span></div>',
            y: -180
          },
          tooltip: {
            // valueSuffix: ' km/h'
          }
        }]
      })
    }
  }
}
</script>

<style scoped>
.dash_board_chart{
  height: 200px;
}
</style>
